import React from "react";
import ModalShell, { ModalSpaList } from "./ModalShell";

interface ModalProps {
  isOpen: boolean;
  setOpen: any;
  setOpenRequest: any;
  spas: any[];
}

const ConfirmLogsModal: React.FC<ModalProps> = ({
  isOpen,
  setOpen,
  setOpenRequest,
  spas,
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    setOpenRequest(true);
    handleClose();
  };

  return (
    <ModalShell
      open={isOpen}
      onClose={handleClose}
      title={spas.length > 1 ? `Request logs from ${spas.length} spas?` : "Request spa logs?"}
      subtitle="Connected spas upload their logs, which then appear on the Logs page."
      actions={
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-primary" disabled={spas.length === 0} onClick={handleConfirm}>
            Request logs
          </button>
        </>
      }
    >
      <ModalSpaList spas={spas} label={spas.length === 1 ? "Spa" : "Spas"}/>
    </ModalShell>
  );
};

export default ConfirmLogsModal;
